import { render, staticRenderFns } from "./monthly_area_product.vue?vue&type=template&id=155d727a&scoped=true"
import script from "./monthly_area_product.vue?vue&type=script&lang=js"
export * from "./monthly_area_product.vue?vue&type=script&lang=js"
import style0 from "./monthly_area_product.vue?vue&type=style&index=0&id=155d727a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155d727a",
  null
  
)

export default component.exports